import React, { Component } from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Text } from '../../extensions/LangaugeContainer';

export default class ConfirmAuftragDialog extends Component {


    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title"><Text tid="orderFinish"/>?</DialogTitle>
                <DialogContent>
                {this.props.type === 0 && (
                  <DialogContentText id="alert-dialog-description">
                    <Text tid="confirmAuftragMessage0"/>
                    {/* Alle positionen sind abgehakt aber der auftrag status is 'Teilweise',Sind Sie sicher dass Sie fortfahren wollen? */}
                  </DialogContentText>
                )}
                {this.props.type === 1 && (
                  <DialogContentText id="alert-dialog-description">
                    <Text tid="confirmAuftragMessage1"/>
                    {/* Nicht alle positionen sind abgehakt aber der auftrag status is 'Fertig',Sind Sie sicher dass Sie fortfahren wollen? */}
                  </DialogContentText>
                )}
                {this.props.type === 2 && (
                  <DialogContentText id="alert-dialog-description">
                    <Text tid="confirmAuftragMessage2"/>
                    {/* Sind Sie sicher dass Sie fortfahren wollen? */}
                  </DialogContentText>
                )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                    <Text tid="cancel"/>
                    </Button>
                    <Button onClick={this.props.finishAuftrag} color="primary" autoFocus>
                    <Text tid="confirm"/>
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}